
//系统目录 / 西药 接口相关的函数
import request from "../../untils/request.js"

/**
 * 
 *  post
 *  
 */

//新增科室档案
export const addDept = (data) => {
    return request.post("/outpatient/addDept", data )
}

//修改科室档案
export const updateDept = (data) => {
    return request.post("/outpatient/updateDept", data )
}

/**
 * 
 *  get
 *  
 */

// 列表
export const getDeptList = (params) => {
    return request.get("/outpatient/getDeptList", { params } )
}
// 
export const getDeptAttribute = (params) => {
    return request.get("/outpatient/getDeptAttribute", { params } )
}
/**
 * 
 * DELETE 
 *  
 */   


// 暴露
export default{
	getDeptList,addDept,updateDept,getDeptAttribute
}